import { render } from "./GoalManagement.vue?vue&type=template&id=2bed2600"
import script from "./GoalManagement.vue?vue&type=script&lang=js"
export * from "./GoalManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__